import React, { useContext, useEffect, useState } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { UserContext } from "../../../../contexts/CurrentUserContext";
import CreateJobType from "./CreateJobType/CreateJobType";
import JobTypesNav from "./JobTypesNav/JobTypesNav";
import UpdateJobType from "./UpdateJobType/UpdateJobType";
import "./JobTypes.css";

const JOB_TYPES_SUB_TABS = [
  {
    id: 1,
    label: "Создание вида работ",
    path: "create",
    Component: CreateJobType,
  },
  {
    id: 2,
    label: "Обновление видов работ",
    path: "update",
    Component: UpdateJobType,
  },
];

function JobTypes() {
  const { userData } = useContext(UserContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(1);

  const canAccessJobTypes =
    userData?.access_levels?.some(
      (level) => level.name === "АДМС" || level.name === "ИК",
    ) || false;

  useEffect(() => {
    const segment = location.pathname.split("/").pop();
    const currentTab =
      JOB_TYPES_SUB_TABS.find((tab) => tab.path === segment) ||
      JOB_TYPES_SUB_TABS[0];
    setActiveTab(currentTab.id);
  }, [location.pathname]);

  const handleTabChange = (tabId) => {
    const tab = JOB_TYPES_SUB_TABS.find((t) => t.id === tabId);
    if (tab) {
      navigate(`/account/admin/job-types/${tab.path}`);
    }
  };

  if (!canAccessJobTypes) {
    return (
      <div className="job-types job-types--denied">
        <p>
          Раздел доступен только пользователям с уровнем доступа АДМС или ИК.
        </p>
      </div>
    );
  }

  return (
    <div className="job-types">
      <JobTypesNav
        activeSubTab={activeTab}
        setActiveSubTab={handleTabChange}
        subTabs={JOB_TYPES_SUB_TABS}
      />
      <div className="job-types__content">
      <Routes>
        {JOB_TYPES_SUB_TABS.map((tab) => (
          <Route key={tab.id} path={tab.path} element={<tab.Component />} />
        ))}
        <Route index element={<Navigate to="create" replace />} />
      </Routes>
      </div>
    </div>
  );
}

export default JobTypes;
